import { Link, useLocation } from "react-router-dom";

/**
 * Shared tab strip for the admin debug pages. Active tab is derived from the
 * current pathname so we don't need to thread state — each admin page just
 * renders <AdminTabs /> near the top and the highlight follows the route.
 */

interface Tab {
  to: string;
  label: string;
  match: (pathname: string) => boolean;
}

const TABS: Tab[] = [
  {
    to: "/admin/find",
    label: "Find vendors",
    match: (p) => p === "/admin/find" || p.startsWith("/admin/find/"),
  },
  {
    to: "/admin/crawl",
    label: "Scan URL",
    match: (p) => p === "/admin/crawl" || p.startsWith("/admin/crawl/"),
  },
];

export function AdminTabs() {
  const { pathname } = useLocation();
  return (
    <div className="mb-6 flex items-center gap-1 text-sm">
      {TABS.map((t) => {
        const active = t.match(pathname);
        return (
          <Link
            key={t.to}
            to={t.to}
            className={
              active
                ? "px-4 py-1.5 rounded-full bg-stone-900 text-stone-50"
                : "px-4 py-1.5 rounded-full text-stone-600 hover:bg-stone-100"
            }
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
